export class ProductModel {
    id: string;
    name: string;
}